import { Link } from "react-router-dom";

interface Backer {
  name: string;
  slug: string;
  round: string | null;
  lead_investor: number;
}

interface BackedBySectionProps {
  backers: Backer[];
}

function roundLabel(round: string | null): string {
  if (!round) return "";
  return round.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function BackedBySection({ backers }: BackedBySectionProps) {
  if (!backers || backers.length === 0) return null;

  return (
    <div className="mb-8">
      <h3 className="text-sm font-semibold text-slate-400 mb-3 flex items-center gap-2">
        <span>{"\u{1F4B0}"}</span> Backed By
      </h3>
      <div className="flex gap-2 flex-wrap">
        {backers.map((backer, i) => (
          <Link
            key={`${backer.slug}-${i}`}
            to={`/vc/${backer.slug}`}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800/60 border border-slate-700/30 hover:border-indigo-500/30 hover:bg-slate-800/80 transition-all group text-sm"
          >
            <span className="text-slate-200 group-hover:text-white font-medium transition-colors">
              {backer.name}
            </span>
            {backer.round && (
              <span className="text-slate-500 text-xs">
                {roundLabel(backer.round)}
              </span>
            )}
            {backer.lead_investor === 1 && (
              <span className="badge bg-amber-500/15 text-amber-300 border border-amber-500/20 text-[10px]">
                Lead
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
